import { Text } from '@agrotoken-tech/ui';

type Props = {
  message: string;
};

export const SectionError = ({ message }: Props) => {
  return <Text>{message}</Text>;
};
